// extracted by mini-css-extract-plugin
export default {"Alert_conponeat":"tostmass_Alert_conponeat__PLwmA","add_new_alert":"tostmass_add_new_alert__ihVEh","box_img_typo":"tostmass_box_img_typo__KtdsU"};